module.exports = __webpack_public_path__ + "static/media/greenApprove.2235dddf.svg";